import { render, staticRenderFns } from "./donationUnitEmailBtns.vue?vue&type=template&id=6b5e867b&"
import script from "./donationUnitEmailBtns.vue?vue&type=script&lang=js&"
export * from "./donationUnitEmailBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports